// extracted by mini-css-extract-plugin
export default {"centerWithoutBackground":"_276cd700"};